import React from 'react';

const SimpleSwitch: React.FC<{
  items: string[];
  activeIndex: number;
  setActiveIndex: (id) => void;
}> = ({ items, activeIndex, setActiveIndex }) => {
  return (
    <div className="flex bg-gray-5 rounded-[23px] text-[14px] md:text-[16px]">
      {items.map((item, index) => (
        <div
          key={item}
          onClick={(): void => setActiveIndex(index)}
          className={`py-1 px-[20px] ${
            (activeIndex || 0) === index ? 'bg-blue-3 text-white' : 'bg-gray-5'
          }   rounded-[23px] cursor-pointer`}
        >
          {item}
        </div>
      ))}
    </div>
  );
};

export default SimpleSwitch;
